// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__3-dEM","legacyBtn":"MutateMid_legacyBtn__kWfGj"};